<template>
  <div>

  

  <div class="form-group_">
    <label v-if="label">{{ label }}</label>
    <div class="input-group mb-2">
    <div class="input-group-prepend">
      <div class="input-group-text perc">%</div>
    </div>   
      <input
        type="number"
        class="form-control"
        :value="displayValue"
        @input="onInput"
        :min="min"
        :max="max"
        step="0.01"
      />

      <div  class="input-group-append" v-if="showAdd">
            <div @click="setClick()" class="input-group-text sconto pointer">+</div>
      </div>

    </div>
  </div>

</div>  
</template>

<script>
export default {
  name: "InputSconto",
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    label: {
      type: String,
      default: ""
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    btn : {type:Boolean,default:true},
     showAdd: {
    type: Boolean,
    default: false
  }
  },
  computed: {
    displayValue() {
      // Gestione stringhe vuote
      return this.value === null || this.value === "" ? "" : Number(this.value);
    }
  },
  methods: {

    setClick()
    {
      this.$emit('add')
    },
    onInput(event) {
      let val = event.target.value;

      // Se è vuoto
      if (val === "") {
        this.$emit("input", 0); // puoi usare 0 oppure null
        return;
      }

      val = Number(val);

      // Corregge valori fuori range
      if (isNaN(val) || val < this.min) val = this.min;
      if (val > this.max) val = this.max;

      // Emissione standard v-model
      this.$emit("input", val);

      // Log opzionale per capire quale input sta cambiando
      console.log(`InputSconto '${this.label}' aggiornato a:`, val);
    }
  }
};
</script>
<style scoped>



.pointer{
  cursor: pointer;
}



.sconto{
  background-color: #ffc107;
  color: black;
}
</style>